import { render, staticRenderFns } from "./ConfigBellOptions.vue?vue&type=template&id=461f7acc&scoped=true"
import script from "./ConfigBellOptions.vue?vue&type=script&lang=js"
export * from "./ConfigBellOptions.vue?vue&type=script&lang=js"
import style0 from "./ConfigBellOptions.vue?vue&type=style&index=0&id=461f7acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f7acc",
  null
  
)

export default component.exports